module.exports = __webpack_public_path__ + "static/media/fd-desk-ok.7cfbcacb.png";